export const constants = {
  relatedApplicationKey: 'relatedApplicationFinished',
  matchedDataHiddenKey: 'matchedDataHidden'
}

export const getRelatedApplicationFinished = () => {
  const relatedApplication = localStorage.getItem(constants.relatedApplicationKey)
  return relatedApplication ? JSON.parse(relatedApplication) : []
}

export const setRelatedApplicationFinished = (toolCallId: string) => {
  const relatedApplication = [...getRelatedApplicationFinished(), toolCallId]
  localStorage.setItem(constants.relatedApplicationKey, JSON.stringify(relatedApplication))
}

// 通用的匹配数据隐藏状态管理
export const getMatchedDataHidden = () => {
  const hidden = localStorage.getItem(constants.matchedDataHiddenKey)
  return hidden ? JSON.parse(hidden) : []
}

export const setMatchedDataHidden = (toolCallId: string) => {
  const hidden = [...getMatchedDataHidden(), toolCallId]
  localStorage.setItem(constants.matchedDataHiddenKey, JSON.stringify(hidden))
}

export const isMatchedDataHidden = (toolCallId: string) => {
  return getMatchedDataHidden().includes(toolCallId)
}